import React from 'react';
import styled from 'styled-components';
import * as RDBCases from '../../../services/buildfire/rdb/cases';
import CaseType from './CaseType';
import SubmitterInfo from './SubmitterInfo';
import PaymentInfo from './PaymentInfo';
import PatientInfo from './PatientInfo';
import SitesList from '../edit/sites/SitesList';

interface EditableCaseInfoProps {
  case: RDBCases.Case;
  bannerContent?: React.ReactNode | string;
  isAdmin: boolean;
  children?: React.ReactNode;
}

const Content = styled.div`
  margin-bottom: 32px;
`;

const SitesContainer = styled.div`
  margin: 32px 0;
`;

const EditableCaseInfo: React.FC<EditableCaseInfoProps> = ({
  bannerContent,
  case: userCase,
  isAdmin,
  children,
}) => {
  return (
    <Content>
      {bannerContent}

      <CaseType case={userCase} isAdmin={isAdmin} />
      <SubmitterInfo case={userCase} />
      <PaymentInfo case={userCase} />
      <PatientInfo case={userCase} />

      <SitesContainer>
        <SitesList
          case={userCase}
          sites={userCase.sites}
          userId={userCase.uid}
        />
      </SitesContainer>
      {children}
    </Content>
  );
};

export default EditableCaseInfo;
